import { truncateAddress } from './string';
export const mapStat = (ensInfo) => (stat, i) => {
    var _a;
    return (Object.assign(Object.assign({}, stat), { trader: stat.account, traderShort: truncateAddress(stat.account), rank: i + 1, rankText: (i + 1).toString(), traderEns: (_a = ensInfo[stat.account]) !== null && _a !== void 0 ? _a : null }));
};
